export default {"SwitchSelected":"a","Switch":"b","MonthBu":"c"}